module.exports = __webpack_public_path__ + "static/media/2nd_banner.964c0241.png";